import { render, staticRenderFns } from "./AnswersCreator.vue?vue&type=template&id=564762c1"
import script from "./AnswersCreator.vue?vue&type=script&lang=js"
export * from "./AnswersCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports